import React from "react";
import { motion } from "framer-motion";
import { ChevronLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PrivacyPage = () => {
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="privacy-page">
      {/* Back Navigation */}
      <Link 
        to="/" 
        className="fixed top-6 left-6 z-50 flex items-center gap-2 text-white/50 hover:text-white transition-colors"
        data-testid="back-to-home"
      >
        <ChevronLeft className="w-5 h-5" />
        <span className="font-accent text-sm uppercase tracking-wider">Back</span>
      </Link>

      {/* Content */}
      <div className="max-w-3xl mx-auto px-6 py-24 md:py-32">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="font-heading font-black text-4xl md:text-5xl uppercase tracking-tight mb-4" style={{ color: "#F4F1E8" }}>
            PRIVACY <span className="text-terracotta">POLICY</span>
          </h1>
          <div className="w-16 h-0.5 mb-10" style={{ background: "#D4AF37" }} />

          <div className="space-y-8 text-white/70 text-base leading-relaxed">
            <p className="text-white/50 text-sm">Last updated: January 2025</p>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Information We Collect</h2>
              <p>When you sign up for notifications or purchase tickets through Cinco De Crawl, we may collect:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>Name and contact information (email, phone number)</li>
                <li>Payment information (processed securely through third-party providers)</li>
                <li>Event preferences and city selections</li>
                <li>Device and usage information when you visit our website</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">How We Use Your Information</h2>
              <p>We use your information to:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>Process ticket purchases and send confirmations</li>
                <li>Send event updates, reminders, and exclusive offers</li>
                <li>Improve our website and event experiences</li>
                <li>Respond to your inquiries and provide customer support</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Information Sharing</h2>
              <p>We do not sell your personal information. We may share your information with:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>Venue partners for event check-in purposes</li>
                <li>Payment processors to complete transactions</li>
                <li>Service providers who help operate our platform</li>
                <li>Law enforcement when required by law</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Your Rights</h2>
              <p>You have the right to:</p>
              <ul className="list-disc list-inside mt-3 space-y-2 text-white/60">
                <li>Access and update your personal information</li>
                <li>Unsubscribe from marketing communications</li>
                <li>Request deletion of your data</li>
                <li>Opt out of certain data collection</li>
              </ul>
            </section>

            <section>
              <h2 className="font-heading font-bold text-xl text-white mb-3">Contact Us</h2>
              <p>If you have questions about this Privacy Policy, please <Link to="/contact" className="text-terracotta hover:text-terracotta-light underline">contact us</Link>.</p>
            </section>
          </div>
        </motion.div>
      </div>

      {/* Footer */}
      <footer className="py-10 px-4 border-t border-white/5" style={{ background: "#050505" }}>
        <div className="max-w-4xl mx-auto text-center">
          <h4 className="font-heading font-bold text-lg mb-1" style={{ color: "#F4F1E8" }}>
            CINCO <span className="text-terracotta">DE</span> CRAWL
          </h4>
          <p className="text-white/30 text-xs mb-4">The Ultimate Bar Crawl Tour</p>
          <p className="text-white/20 text-xs">© 2026 Cinco De Crawl. Must be 21+.</p>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPage;
